import { Shell } from "../shell/Shell";

/** A screen that exists in the plan but not yet in the product: it says which milestone brings it, in the shell, so the rail and
 *  the switcher work everywhere from the first day of M1. */
export function Placeholder({ title, milestone, what }: { title: string; milestone: string; what: string }) {
  return (
    <Shell crumbs={[{ label: title }]} bodyClassName="ob-body--full">
      <main className="ob-placeholder" aria-label={title}>
        <div className="ob-placeholder__box"><h1 className="ob-placeholder__title">{title}</h1><p className="ob-placeholder__line">{what} It arrives with {milestone}.</p></div>
      </main>
    </Shell>
  );
}
